/* ThaBel — avisos, cabeçalho (megamenu, busca, menu do celular) e rodapé */
(() => {
  if (window.tbLayoutPronto) return;
  window.tbLayoutPronto = true;

  const semMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = () => window.matchMedia('(min-width: 990px)').matches;

  /* ---------- Avisos ---------- */
  class TbAvisos extends HTMLElement {
    connectedCallback() {
      this.itens = [...this.querySelectorAll('.tb-avisos__item')];
      this.atual = 0;
      if (this.itens.length < 2) return;
      this.querySelectorAll('[data-tb-aviso]').forEach((b) => b.addEventListener('click', () => { this.ir(this.atual + Number(b.dataset.tbAviso)); this.reiniciar(); }));
      this.addEventListener('mouseenter', () => this.parar());
      this.addEventListener('mouseleave', () => this.reiniciar());
      this.addEventListener('focusin', () => this.parar());
      this.reiniciar();
    }
    ir(i) {
      this.atual = (i + this.itens.length) % this.itens.length;
      this.itens.forEach((el, k) => { el.hidden = k !== this.atual; el.classList.toggle('is-ativo', k === this.atual); });
    }
    parar() { clearInterval(this.timer); }
    reiniciar() {
      this.parar();
      const s = Number(this.dataset.intervalo || 0);
      if (s > 0 && !semMovimento) this.timer = setInterval(() => this.ir(this.atual + 1), s * 1000);
    }
  }
  if (!customElements.get('tb-avisos')) customElements.define('tb-avisos', TbAvisos);

  /* ---------- Cabeçalho ---------- */
  class TbCabecalho extends HTMLElement {
    connectedCallback() {
      this.sombra = this.querySelector('[data-tb-sombra]');
      this.prepararMega();
      this.prepararBusca();
      this.prepararMenuCelular();
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.megaAberto) { const b = this.megaAberto.botao; this.fecharMega(); this.semFoco = true; b.focus(); this.semFoco = false; }
        if (!this.busca.hidden) this.fecharBusca(true);
        if (!this.menuCel.hidden) this.fecharMenuCelular();
      });
    }

    /* megamenu */
    prepararMega() {
      this.querySelectorAll('[data-tb-item]').forEach((item) => {
        const botao = item.querySelector('[data-tb-mega-botao]');
        const painel = item.querySelector('[data-tb-mega]');
        if (!botao || !painel) return;
        const ref = { item, botao, painel };
        botao.addEventListener('click', (e) => {
          /* toque (tablet): o 1º toque abre o menu, o 2º entra na categoria; no mouse o clique já entra direto */
          if (desktop() && window.matchMedia('(hover: none)').matches && this.megaAberto !== ref) { e.preventDefault(); this.abrirMega(ref); }
        });
        botao.addEventListener('focus', () => { if (desktop() && !this.semFoco) this.abrirMega(ref); });
        item.addEventListener('mouseenter', () => {
          if (!desktop()) return;
          clearTimeout(this.saida);
          this.entrada = setTimeout(() => this.abrirMega(ref), this.megaAberto ? 0 : 120);
        });
        item.addEventListener('mouseleave', () => {
          clearTimeout(this.entrada);
          this.saida = setTimeout(() => { if (this.megaAberto === ref) this.fecharMega(); }, 200);
        });
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget) && this.megaAberto === ref) this.fecharMega();
        });
      });
      this.sombra?.addEventListener('click', () => { this.fecharMega(); this.fecharBusca(); });
    }
    abrirMega(ref) {
      if (this.megaAberto && this.megaAberto !== ref) this.fecharMega(true);
      this.megaAberto = ref;
      ref.painel.hidden = false;
      ref.botao.setAttribute('aria-expanded', 'true');
      ref.item.classList.add('is-aberto');
      if (this.sombra) this.sombra.hidden = false;
    }
    fecharMega(trocando) {
      const ref = this.megaAberto;
      if (!ref) return;
      ref.painel.hidden = true;
      ref.botao.setAttribute('aria-expanded', 'false');
      ref.item.classList.remove('is-aberto');
      this.megaAberto = null;
      if (this.sombra && !trocando && this.busca.hidden) this.sombra.hidden = true;
    }

    /* busca com sugestões */
    prepararBusca() {
      this.busca = this.querySelector('[data-tb-busca]');
      this.campo = this.querySelector('[data-tb-busca-campo]');
      this.resultados = this.querySelector('[data-tb-busca-resultados]');
      this.moeda = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
      this.querySelectorAll('[data-tb-busca-abrir]').forEach((b) => b.addEventListener('click', () => this.abrirBusca(b)));
      this.querySelector('[data-tb-busca-fechar]')?.addEventListener('click', () => this.fecharBusca(true));
      this.campo?.addEventListener('input', () => {
        clearTimeout(this.esperaBusca);
        this.esperaBusca = setTimeout(() => this.sugerir(this.campo.value.trim()), 250);
      });
    }
    abrirBusca(gatilho) {
      this.fecharMega();
      this.gatilhoBusca = gatilho;
      this.busca.hidden = false;
      if (this.sombra) this.sombra.hidden = false;
      this.campo.focus();
    }
    fecharBusca(devolverFoco) {
      if (!this.busca || this.busca.hidden) return;
      this.busca.hidden = true;
      if (this.sombra && !this.megaAberto) this.sombra.hidden = true;
      if (devolverFoco) this.gatilhoBusca?.focus();
    }
    async sugerir(q) {
      if (!this.resultados) return;
      if (q.length < 2) { this.resultados.innerHTML = ''; return; }
      try {
        const url = `${this.dataset.buscaUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
        const d = await fetch(url).then((r) => r.json());
        const prods = (d.resources && d.resources.results && d.resources.results.products) || [];
        const cols = (d.resources && d.resources.results && d.resources.results.collections) || [];
        const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        if (!prods.length && !cols.length) {
          this.resultados.innerHTML = `<p class="tb-busca__vazio">Nada encontrado para "${esc(q)}".</p>`;
          return;
        }
        const htmlCols = cols.length
          ? `<div class="tb-busca__cols">${cols.slice(0, 3).map((c) => `<a href="${esc(c.url)}" class="tb-busca__col">${esc(c.title)}</a>`).join('')}</div>`
          : '';
        const htmlProds = prods.map((p) => {
          const img = p.featured_image && p.featured_image.url ? `<img src="${esc(p.featured_image.url)}&width=120" alt="" width="60" height="60" loading="lazy">` : '<span></span>';
          const preco = Number(p.price) ? this.moeda.format(Number(p.price)) : '';
          return `<li><a href="${esc(p.url)}" class="tb-busca__prod">${img}<span><strong>${esc(p.title)}</strong><span>${preco}</span></span></a></li>`;
        }).join('');
        this.resultados.innerHTML = `${htmlCols}<ul class="tb-busca__lista" role="list">${htmlProds}</ul><a class="tb-busca__todos" href="/search?q=${encodeURIComponent(q)}&options[prefix]=last">Ver todos os resultados para "${esc(q)}"</a>`;
      } catch (e) {
        this.resultados.innerHTML = '';
      }
    }

    /* menu do celular */
    prepararMenuCelular() {
      this.menuCel = this.querySelector('[data-tb-menu-celular]');
      this.botaoMenu = this.querySelector('[data-tb-menu-abrir]');
      this.botaoMenu?.addEventListener('click', () => this.abrirMenuCelular());
      this.querySelectorAll('[data-tb-menu-fechar]').forEach((b) => b.addEventListener('click', () => this.fecharMenuCelular()));
      this.menuCel?.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        const f = [...this.menuCel.querySelectorAll('a[href], button, summary')].filter((el) => el.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
    }
    abrirMenuCelular() {
      this.menuCel.hidden = false;
      this.botaoMenu.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('tb-sem-rolagem');
      requestAnimationFrame(() => {
        this.menuCel.classList.add('is-aberto');
        this.menuCel.querySelector('[data-tb-menu-fechar].tb-cab__icone')?.focus();
      });
    }
    fecharMenuCelular() {
      if (!this.menuCel || this.menuCel.hidden) return;
      this.menuCel.classList.remove('is-aberto');
      this.botaoMenu.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('tb-sem-rolagem');
      setTimeout(() => { this.menuCel.hidden = true; }, semMovimento ? 0 : 250);
      this.botaoMenu.focus();
    }
  }
  if (!customElements.get('tb-cabecalho')) customElements.define('tb-cabecalho', TbCabecalho);

  /* ---------- Rodapé: colunas abertas no computador, sanfona no celular ---------- */
  const ajustarRodape = () => {
    document.querySelectorAll('[data-tb-rodape-col]').forEach((d) => { d.open = desktop(); });
  };
  const iniciarRodape = () => {
    ajustarRodape();
    window.matchMedia('(min-width: 990px)').addEventListener('change', ajustarRodape);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarRodape);
  else iniciarRodape();
})();
